import { TeamDetailItemProps } from "./components/TeamDetailItem";
export const TEAM_FULL_IMG = require("./assets/team-full.jpg");

export const TEAM_DETAIL_DATA: TeamDetailItemProps[] = [
  {
    src: require("./assets/member-1.png"),
    name: "Trần Trọng Hải",
    title: "CEO",
    text: `Thạc sĩ Quản trị Truyền thông, hiện là giảng viên ngành Digital Marketing tại trường FPT Polytechnic. Với kinh nghiệm làm cho các tập doanh nghiệp lớn như FPT, VTC, BIDV,... Trọng Hải luôn nỗ lực đem đến cho khách hàng những chiến lược truyền thông hiệu quả nhất.
    `,
  },
  {
    src: require("./assets/member-2.png"),
    name: " Ngô Minh Quân",
    title: "CTO",
    text: `Thạc sỹ, Kỹ sư lập trình cao cấp - tốt nghiệp tại Đại học Monash Úc, đồng thời là Giám đốc Công ty công nghệ YoungPilots, Minh Quân  đã  từng  làm  việc  cho  nhiều  doanh nghiệp  lớn  của  Việt  Nam  và  nước  ngoài. Minh Quân luôn có những ý tưởng và giải pháp tối ưu về công nghệ cho khách hàng.
    `,
  },
  {
    src: require("./assets/member-3.png"),
    name: "Nguyễn Diễm My",
    title: "COO",
    text: `Thạc sỹ Quản trị Truyền thông. Với nhiều năm kinh nghiệm làm việc với các doanh nghiệp trong các ngành sản phẩm dịch vụ như Tài chính, Công nghệ, Chăm sóc sức khỏe, Giải trí..., Diễm My tự tin mang đến cho khách hàng những chiến lược bài bản, chuyên nghiệp và vô cùng sáng tạo. Sự kiểm soát chặt chẽ kế hoạch, vận hành kế hoạch và đánh giá hiệu quả sau mỗi chiến dịch là một lợi thế của Diễm My trong hoạt động Marcom của Express Agency.`,
    alignRight: true,
  },
  {
    src: require("./assets/member-4.png"),
    name: "Trần Duyên Hải",
    title: "CFO",
    text: `Tốt nghiệp Thạc sĩ Quản trị Kinh doanh của Đại học Marshall, Mỹ, Hải hiện là Giám đốc Điều hành Golden Palace - chuỗi nhà hàng, khách sạn sang trọng. Có kinh nghiệm quản lý và vận hành, Hải có thể giám sát và phát triển kinh doanh, tài chính dự án.`,
    alignRight: true,
  },
];



// WEBPACK FOOTER //
// ./src/routes/Team/constants.ts